import React from 'react';
import { Loader2 } from 'lucide-react';
import { cn } from 'lib/utils';

interface LoadingProps {
    fullScreen?: boolean;
    text?: string;
    size?: 'small' | 'medium' | 'large';
}

const sizeMap = {
    small: 'h-4 w-4',
    medium: 'h-6 w-6',
    large: 'h-8 w-8',
};

const Loading: React.FC<LoadingProps> = ({
    fullScreen = false,
    text = '로딩 중...',
    size = 'medium',
}) => {
    return (
        <div
            className={cn(
                'flex items-center justify-center text-muted-foreground',
                fullScreen
                    ? 'fixed inset-0 z-50 bg-background/80 backdrop-blur-sm'
                    : 'w-full py-12'
            )}
        >
            <div className="flex flex-col items-center gap-3">
                <Loader2 className={cn('animate-spin text-primary', sizeMap[size])} />
                {text && <p className="text-sm">{text}</p>}
            </div>
        </div>
    );
};

export default Loading;
